import { Header } from '@/components/Header';
import { BulkImport } from '@/pages/BulkImport';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/_admin/admin/manage-users/import'
)({
  component: BulkImportPage,
});

function BulkImportPage() {
  return (
    <>
      <Header enableBack additionalClasses="bg-slate-700" />
      <BulkImport />
    </>
  );
}

